export const kindergartenDayOffReadDayOffTypeData = [
  {
    value: 'principal_day_off',
    text: 'Ředitelské volno',
  },
  { value: 'school_holiday', text: 'Prázdniny' },
  { value: 'other', text: 'Jiné' },
];
